// eslint-disable-next-line no-restricted-imports
import { SessionType } from '@sketch/gql-types/expansive'
import { getBrowserFromUserAgent } from '@sketch/utils'

/**
 * Returns the correct device name string based on the type and user agent of
 * the device.
 * e.g. Sketch for Mac on John's iMac
 */
export const getDeviceNameString = (
  type: SessionType | null,
  userAgent: string | null,
  name: string | null
): string => {
  if (type === 'WEB') {
    return `Sketch Web App on ${getBrowserFromUserAgent(userAgent || '')}`
  }

  // Since it's not a Web session we should use the userAgent to check
  // if it's iOS or macOS
  const device = userAgent?.split('/')[0]

  if (device === 'iOS') return `Sketch for iPhone on ${name}`

  if (device === 'macOS') return `Sketch for Mac on ${name}`

  return `Sketch on ${name}`
}
